var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGooglePay = function SvgIconGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#fff",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    fillRule: "evenodd",
    d: "M16.53 15.758v-3.02h1.56c.638 0 1.177-.215 1.617-.637l.106-.107a2.175 2.175 0 0 0-.106-3.045 2.23 2.23 0 0 0-1.618-.648h-2.503v7.457zm0-3.937V9.217h1.583c.34 0 .663.13.903.368.51.5.522 1.332.03 1.85-.241.255-.581.398-.933.386zm7.685-.767q-.608-.563-1.653-.565-1.347.002-2.017.993l.833.53q.457-.678 1.248-.678c.334 0 .657.125.909.35.246.215.387.524.387.851v.22c-.364-.202-.821-.31-1.384-.31-.656 0-1.184.155-1.576.47-.393.316-.593.732-.593 1.261-.011.482.194.94.557 1.25.37.332.839.499 1.39.499.65 0 1.166-.292 1.559-.875h.04v.708h.903v-3.146c0-.66-.199-1.183-.603-1.558m-2.562 3.765a.78.78 0 0 1-.31-.625q.002-.42.38-.696.39-.278.962-.28.792-.006 1.231.352-.001.606-.469 1.052a1.5 1.5 0 0 1-1.06.446 1.14 1.14 0 0 1-.734-.25M26.847 18 30 10.656h-1.026l-1.46 3.663h-.017l-1.494-3.663h-1.026l2.069 4.775L25.874 18z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.272 12.083q0-.438-.07-.868h-3.98v1.647h2.28a1.98 1.98 0 0 1-.844 1.302v1.07h1.36c.797-.743 1.254-1.843 1.254-3.151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9.222 16.27c1.137 0 2.098-.381 2.796-1.035l-1.36-1.07c-.38.261-.867.41-1.436.41-1.102 0-2.034-.756-2.368-1.766H5.453v1.106a4.21 4.21 0 0 0 3.769 2.355"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M6.854 12.809a2.62 2.62 0 0 1 0-1.642v-1.1H5.453a4.3 4.3 0 0 0 0 3.842z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9.222 9.401a2.25 2.25 0 0 1 1.618.642l1.207-1.225a4.04 4.04 0 0 0-2.825-1.112 4.22 4.22 0 0 0-3.769 2.361l1.4 1.106c.335-1.017 1.267-1.772 2.369-1.772"
  })));
};
export default SvgIconGooglePay;